'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
// debugger;
var tree = document.querySelector('#tree');
// function createTree(element, data) {
//   const ul = document.createElement('ul');
//   for (const branch in data) {
//     if (Object.keys(data[branch]).length === 0) {
//       ul.insertAdjacentHTML('beforeend', `<li>${branch}</li>`);
//     } else {
//       ul.insertAdjacentElement('beforeend', createTree(ul, data[branch]));
//     }
//   }
//   return ul;
// }
function createTree(element, data) {
    var ul = document.createElement('ul');
    // create new branch
    for(var branch in data){
        var li = document.createElement('li');
        // create new list item
        li.insertAdjacentText('beforeend', "".concat(branch));
        // add name to the list item
        if (Object.keys(data[branch]).length > 0) createTree(li, data[branch]);
        ul.insertAdjacentElement('beforeend', li);
    // add current list item to branch
    }
    element.insertAdjacentElement('beforeend', ul);
// add completed barnch to parent branch
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.c0280c20.js.map
